export default "__VITE_ASSET__3U3WBzLJ__"